import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchNotifications } from "../../features/admin/PostsSlice";
import TableComponent from "../../components/TableComponent";
import ApiCustom from "../../utils/ApiCustom";

import {
  PencilSquareIcon,
  TrashIcon,
  CheckCircleIcon,
  GiftIcon,
  XMarkIcon,
  DocumentTextIcon,
  XCircleIcon,
  InformationCircleIcon,
} from "@heroicons/react/24/outline";
import { deletePost } from "../../features/admin/PostsSlice";
import { toast } from "react-toastify";
import {
  fetchCategoryByType,
  fetchCategoryByTypePublic,
} from "../../features/admin/CategorySlice";
import ConfirmDeleteModal from "../../components/ConfirmDeleteModal";
import { fetchPartners } from "../../features/admin/PartnerSlice";
import NotiModal from "../../components/admin/NotiModal";
import NotiPreview from "../../components/admin/NotiPreview";
import { fetchRegistration } from "../../features/admin/RegistrationSlice";
import EventModal from "../../components/admin/eventModal";
import ConfirmCancleApproveModal from "../../components/ConfirmCancleApproveModal";
import ConfirmApproveModal from "../../components/ConfirmApproveModal";

const Posts = () => {
  const dispatch = useDispatch();
  const {
    authNotifications: posts,
    authNotificationStatus: status,
    authNotificationError: error,
  } = useSelector((state) => state.posts);
  const { registrations } = useSelector((state) => state.registrations);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isOpenEvent, setIsOpenEvent] = useState(false);
  const [isModalPreview, setIsModalPreview] = useState(false);
  const [currentPost, setCurrentPost] = useState(null);
  const { categories } = useSelector((state) => state.categories);
  const [deleteId, setDeleteId] = useState(null);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [currentEvent, setCurrentEvent] = useState(null);
  const [eventPostId, setEventPostId] = useState(null);
  const [isCancelApproveOpen, setIsCancelApproveOpen] = useState(false);
  const [isApproveOpen, setIsApproveOpen] = useState(false);

  const hasPermission = (requiredPermission) => {
    const userId = localStorage.getItem("userId");
    if (userId == 1) {
      return true;
    }
    const userPermissions = getUserPermissions();
    return userPermissions.includes(requiredPermission);
  };

  const getUserPermissions = () => {
    const permissions = localStorage.getItem("permissions");
    return permissions
      ? JSON.parse(permissions)?.map((p) => p.permissionSlug)
      : [];
  };

  const [statusFilter, setStatusFilter] = useState("all");

  const handleOpenDeleteModal = (id) => {
    setDeleteId(id);
    setIsDeleteOpen(true);
  };

  const handleOpenCancleApproveModal = (post) => {
    setCurrentPost(post);
    setIsCancelApproveOpen(true);
  };

  const handleCloseCancelApproveModal = () => {
    setIsCancelApproveOpen(false);
    setCurrentPost(null);
    dispatch(fetchNotifications());
  };

  const handleCloseApproveModal = () => {
    setIsApproveOpen(false);
    setCurrentPost(null);
    dispatch(fetchNotifications());
  };

  const handleCloseDeleteModal = () => {
    setDeleteId(null);
    setIsDeleteOpen(false);
  };

  const handleOpenModal = (post = null) => {
    setCurrentPost(post);
    setIsModalOpen(true);
  };

  const handleOpenEvent = (id) => {
    ApiCustom.get("/event-show-by-post-id/" + id)
      .then((res) => {
        if (res.data.data.length > 0) {
          setCurrentEvent(res.data.data[0]);
        } else {
          setEventPostId(id);
        }
        setIsOpenEvent(true);
      })
      .catch((err) => console.log(err));
  };

  // const handleOpenModalPreview = (user = null) => {
  //   setCurrentUser(user);
  //   setIsModalPreview(true);
  // };

  const handleOpenApproveModal = (post = null) => {
    setCurrentPost(post);
    setIsApproveOpen(true);
  };

  const handleApprove = () => {
    ApiCustom.put("/notification-approve/" + currentPost?.id, {
      status: "published",
    })
      .then((res) => {
        if (res.status == 200) {
          setTimeout(() => {
            toast.success("duyệt thông báo thành công!");
          }, 300);

          handleCloseApproveModal();
          handleCloseCancelApproveModal();
        }
      })
      .catch((err) => console.log(err));
  };

  const handleCancelApprove = () => {
    ApiCustom.put("/notification-approve/" + currentPost?.id, {
      status: "draft",
    })
      .then((res) => {
        if (res.status == 200) {
          setTimeout(() => {
            toast.success("Đã huỷ duyệt thông báo");
          }, 300);

          handleCloseApproveModal();
          handleCloseCancelApproveModal();
        }
      })
      .catch((err) => console.log(err));
  };

  const handleCloseModalPreview = () => {
    setIsModalPreview(false);
    setCurrentPost(null);
    dispatch(fetchNotifications());
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setCurrentPost(null);
  };

  const handleCloseEvent = () => {
    setIsOpenEvent(false);
    setCurrentEvent(null);
    setEventPostId(null);
  };

  const handleDelete = async () => {
    await dispatch(deletePost(deleteId)).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        handleCloseDeleteModal();
        toast.success("Xóa bài viết thành công!");
      } else {
        if (res.payload.status == 400) {
          toast.error(res.payload.messages);
          return;
        }
        toast.error("Đã xảy ra lỗi khi xóa bài viết!");
      }
    });
  };

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchNotifications());
      dispatch(fetchPartners);
    }
  }, [status, dispatch]);

  const userId = localStorage.getItem("userId");
  useEffect(() => {
    window.scrollTo(0, 0);
    if (userId == 1) {
      dispatch(fetchCategoryByTypePublic("notification"));
    } else {
      dispatch(fetchCategoryByType("notification"));
    }
    dispatch(fetchRegistration());
  }, [dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (status === "loading") {
    return <p>Loading...</p>;
  }

  if (status === "failed") {
    return <p>Error: {error}</p>;
  }

  // Filter posts based on status
  const filteredPosts =
    statusFilter === "all"
      ? posts
      : posts
          ?.filter((e) => e.type === "notification")
          ?.filter((post) => post.status === statusFilter);
  const headers = [
    { key: "title", label: "Tiêu đề" },
    {
      key: "category",
      label: "Danh mục",
      render: (item) => <div>{item.category?.name}</div>,
    },
    {
      key: "status",
      label: "Trạng thái",
      render: (item) => (
        <span
          className={`px-3 py-1 rounded-full text-sm ${
            item.status === "published"
              ? "bg-green-100 text-green-800"
              : "bg-yellow-100 text-yellow-800"
          } whitespace-nowrap`}
        >
          {item.status === "published" ? "Đã duyệt" : "Chờ duyệt"}
        </span>
      ),
    },
  ];

  if (
    hasPermission("POST_UPDATE") ||
    hasPermission("POST_DELETE") ||
    hasPermission("EVENT_SHOWS") ||
    hasPermission("NOTIFICATION_APPROVE")
  ) {
    headers.push({ key: "setting", label: "Phương thức" });
  }

  const tableSettings = {
    renderSettings: (item) => (
      <div className="flex space-x-2">
        {hasPermission("NOTIFICATION_APPROVE") && (
          <button
            onClick={() =>
              item.status == "draft"
                ? handleOpenApproveModal(item)
                : handleOpenCancleApproveModal(item)
            }
            className={`btn btn-outline ${
              item.status == "published" ? "btn-error" : "btn-success"
            } btn-sm px-3 my-1 rounded`}
            title={item.status == "published" ? "Huỷ duyệt" : "Duyệt"}
          >
            {item.status == "published" ? (
              <XCircleIcon className="w-5 h-5" />
            ) : (
              <CheckCircleIcon className="w-5 h-5" />
            )}
          </button>
        )}
        {hasPermission("POST_UPDATE") && (
          <button
            onClick={() => handleOpenModal(item)}
            // disabled={item.status == "published"}
            className={`btn btn-outline ${
              item.status == "published" ? "btn-primary" : "btn-warning"
            } btn-sm px-3 my-1 rounded`}
            title={item.status == "published" ? "Chi tiết" : "Chỉnh sửa"}
          >
            {item.status == "published" ? (
              <InformationCircleIcon className="w-5 h-5" />
            ) : (
              <PencilSquareIcon className="w-5 h-5" />
            )}
          </button>
        )}
        {hasPermission("EVENT_SHOWS") && (
          <button
            onClick={() => handleOpenEvent(item.id)}
            className="btn btn-outline btn-success btn-sm px-3 my-1 rounded "
            title="Thiệp mời sự kiện"
          >
            <DocumentTextIcon className="w-5 h-5" />
          </button>
        )}
        {hasPermission("POST_DELETE") && (
          <button
            onClick={() => handleOpenDeleteModal(item.id)}
            className=" btn btn-outline btn-error btn-sm px-3 my-1 rounded"
            disabled={item.status == "published"}
            title="Xóa"
          >
            <TrashIcon className="w-5 h-5" />
          </button>
        )}
      </div>
    ),
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold mb-4">Quản lý thông báo</h1>
      <div className="block md:flex justify-between items-center mb-4">
        {hasPermission("POST_CREATE") ? (
          <button
            onClick={() => handleOpenModal()}
            className="btn btn-success transition-colors px-4 py-2 mb-4 rounded"
          >
            + Thêm thông báo
          </button>
        ) : (
          <div></div>
        )}
        <div className="flex items-center space-x-2">
          <label htmlFor="userTypeFilter" className="text-sm font-medium">
            Trạng thái:
          </label>
          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            className="select select-bordered select-sm"
          >
            <option value="all">Tất cả bài viết</option>
            <option value="published">Đã duyệt</option>
            <option value="draft">Chờ duyệt</option>
          </select>
        </div>
      </div>
      <TableComponent
        headers={headers}
        data={filteredPosts}
        settings={tableSettings}
      />

      {isModalOpen && (
        <NotiModal
          postId={currentPost?.id || null}
          onClose={handleCloseModal}
          canUpdate={
            currentPost != null ? currentPost.status !== "published" : true
          }
        />
      )}

      {isModalPreview && (
        <NotiPreview
          post={currentPost}
          onClose={handleCloseModalPreview}
          registrations={registrations}
        />
      )}
      <ConfirmDeleteModal
        isOpen={isDeleteOpen}
        onClose={handleCloseDeleteModal}
        onConfirm={handleDelete}
      />

      <EventModal
        isOpen={isOpenEvent}
        data={currentEvent}
        eventPostId={eventPostId}
        onClose={handleCloseEvent}
      />
      <ConfirmApproveModal
        isOpen={isApproveOpen}
        onClose={handleCloseApproveModal}
        onConfirm={handleApprove}
      />
      <ConfirmCancleApproveModal
        isOpen={isCancelApproveOpen}
        onClose={handleCloseCancelApproveModal}
        onConfirm={handleCancelApprove}
      />
    </div>
  );
};

export default Posts;
